/**
 * Simple templates scripts
 */

(function() {
	/**
	 * Major elements
	 */
	const mainArchiveGallery = document.getElementById('simple-templates-archive-gallery');
	const simpleTemplatesMoreBtn = document.getElementById('simple-templates-more-btn');
	const simpleTemplateGeneralCategory = document.getElementById('simple-templates-general-archive');
	const downloadFormWrapper = document.getElementById('st-form-card');
	const downloadForm = document.getElementById('st-form-card-form');
	const singleDownloadModal = document.getElementById('st-single-download-modal');

	/**
	 * Functions
	 */

	/**
	 * Gets the current post grab stage
	 * @param {*} posts The posts that are currently on the page
	 */
	const getStage = (posts) => {
		// If no posts then we dump
		if (!posts) {
			return;
		}

		// Now the last post will likely contain the latest stage
		const lastPost = posts[posts.length - 1];

		// Grab the stage
		const stage = lastPost.dataset.stage;

		// Now lets check
		if (!stage) {
			return 'init';
		} else {
			return stage;
		}

	}

	/**
	 * Masonry
	 */
	let msnry = null;

	/**
	 * Gallery Page
	 */
	if (mainArchiveGallery) {
		// Once the masorny script has loaded, lets initialize it
		msnry = new Masonry( mainArchiveGallery, {
			// options...
			itemSelector: '.simple-templates-archive-card',
			gutter: '.gutter-sizer',
			initLayout: false,
		});

		// Watch for the complete
		msnry.on('layoutComplete', function() {
			// Grab the data-loaded attribute and the data-needs-loaded attribute
			const loaded = mainArchiveGallery.dataset.loaded === "true";
			const needsLoaded = mainArchiveGallery.dataset.needsLoaded === "true";

			// If its loaded we want to return or i
			if (loaded || !needsLoaded) {
				return;
			}

			// If not, lets swap out the loader and show the masonry
			const container = document.querySelector('.simple-templates-archive-gallery-container');
			const loader = document.querySelector('.simple-templates-archive-gallery-loader');

			// Lets remove the loader
			loader.remove();

			// Now lets show the masonry
			container.classList.remove('h-0');
			container.classList.remove('overflow-hidden');

			// Now lets set the loaded attribute to true
			mainArchiveGallery.dataset.loaded = "true";
		});

		// Now lets layout
		msnry.layout();
	}


	const submitHubspotForm = (form, connector, redirect, postName, region, formId, portalId) => {
		console.log('Submitting form');
		// Missing one? Bye
		if (!form || !connector || !redirect || !postName || !region || !formId || !portalId) {
			return;
		}

		// Lets get the email input value
		const email = form.querySelector('input[type="email"]').value;

		// If there is no email, then we want to alert the user
		if (!email) {
			alert('Please enter your email address');
			return;
		}

		// Lets construct a URL
		const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;

		// Now lets build out the form data
		const data = {
			fields: [
				{
					objectTypeId: "0-1",
					name: "email",
					value: email,
				},
				{
					objectTypeId: "0-1",
					name: "platform",
					value: connector,
				},
				{
					objectTypeId: "0-1",
					name: "redirect_url",
					value: redirect,
				},
				{
					objectTypeId: "0-1",
					name: "template",
					value: postName,
				},
			],
			context: {
				pageUri: window.location.href,
				pageName: document.title
			}
		};

		// If there is a hubspot cookie, then lets add it to the data
		if (document.cookie.includes('hubspotutk')) {
			// Get the cookie value
			const cookie = document.cookie.split(';').find(cookie => cookie.includes('hubspotutk')).split('=')[1];

			// Add the cookie to the data
			data.context.hutk = cookie;
		}

		// Convert the data to JSON
		const json = JSON.stringify(data);

		// Now lets submit the form
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: json,
		})
		.then(response => response.json())
		.then(data => {
			// Check the status for an error
			if (data.status === 'error') {
				alert('There was an error submitting your email. Please try again.');
				return;
			}

			// Redirect the user in a new tab
			window.open(redirect, '_blank');

			// Now lets reset the form
			downloadForm.reset();

			// Now lets hide the form wrapper if its not already hidden
			if (downloadFormWrapper && !downloadFormWrapper.classList.contains('hidden')) {
				downloadFormWrapper.classList.add('hidden');
			}

			// If there is a single download modal, lets close it
			if (singleDownloadModal) {
				singleDownloadModal.classList.remove('show');
			}

			// If we have GTM, then we want to fire an event on the form submission
			if (typeof gtag === "function") {
				gtag("event", "simple_template_download", {
					"event_callback": function() {
						console.log("GTAG fired: simple_template_download");
					}
				});
			}
		})
		.catch(error => {
			console.log(error);
			alert('There was an error submitting your email. Please try again.');
		});
	}

  /**
   * Trigger the single simple template modal by first asking for email. When <form id="st-single-download-form" submit button is clicked it will trigger the hubspot form submission.
   */
  const stSingleDownloadForm = document.getElementById('st-single-download-form');
  const stSubmitBtn = document.getElementById('st-single-download-form-submit');
  if (stSubmitBtn) {
    stSubmitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const email = document.getElementById('st-single-download-form-email').value;
      if (email === '') {
        alert('Please enter your email address');
        return;
      }

      //get the modal Download form
      const modalDownloadForm = document.getElementById('st-single-download-modal-form');
      modalDownloadForm.querySelector('input#st-single-download-box-email').value = email;

      const googleSheetsDownloadBtn = document.getElementById('st-click-google-sheets-download');
      const excelDownloadBtn = document.getElementById('st-click-excel-download');

      //if either excelDownloadBtn or googleSheetsDownloadBtn is false, then that means there is only one download option
      //in that case we do not need to show the modal, we can just submit the form for the user
      //but we have to set the platform and redirect url first before submitting the form
      //otherwise, we show the modal and watch the form
      if (!googleSheetsDownloadBtn || !excelDownloadBtn) {
        //set the redirect for the option that is available
        if (googleSheetsDownloadBtn) {
          modalDownloadForm.dataset.redirect = modalDownloadForm.dataset.sheetsUrl;
          modalDownloadForm.dataset.platform = 'sheets';
        }
        if (excelDownloadBtn) {
          modalDownloadForm.dataset.redirect = modalDownloadForm.dataset.excelUrl;
          modalDownloadForm.dataset.platform = 'excel';
        }

        //set the form vars
        const { platform, redirect, template, region, formId, portalId } = modalDownloadForm.dataset;
        submitHubspotForm(modalDownloadForm, platform, redirect, template, region, formId, portalId);

      } else {
        singleDownloadModal.classList.add('show');

        //add a listener to #st-click-google-sheets-download to trigger setting the redirect url to the google sheets download


          googleSheetsDownloadBtn.addEventListener('click', (e) => {
            e.preventDefault();
            modalDownloadForm.dataset.redirect = modalDownloadForm.dataset.sheetsUrl;
            modalDownloadForm.dataset.platform = 'sheets';
            //give this a class of 'clicked-st-download'
            excelDownloadBtn.classList.remove('clicked-st-download');
            googleSheetsDownloadBtn.classList.add('clicked-st-download');
          });


          excelDownloadBtn.addEventListener('click', (e) => {
            e.preventDefault();
            modalDownloadForm.dataset.redirect = modalDownloadForm.dataset.excelUrl;
            modalDownloadForm.dataset.platform = 'excel';
            //remove other instance of .clicked-st-download class
            googleSheetsDownloadBtn.classList.remove('clicked-st-download');
            excelDownloadBtn.classList.add('clicked-st-download');
          });


        //watch the form
        modalDownloadForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const {platform, redirect, template, region, formId, portalId} = modalDownloadForm.dataset;
          submitHubspotForm(modalDownloadForm, platform, redirect, template, region, formId, portalId);
        });

      }


    });
  }


  /**
   * Download modal
   */
  if (singleDownloadModal) {
    // This has to be a single, so lets get the buttons
    const buttons = document.querySelectorAll('.simple-templates-download-button');

    // Get the modal form
    const modalForm = singleDownloadModal.querySelector('form');

		// Watch the buttons
		buttons.forEach((button) => {
			button.addEventListener('click', (e) => {
				// Stop the default action
				e.preventDefault();

				// Grab the data attributes
				const redirect = button.dataset.redirect;
				const postName = button.dataset.template;
				const connector = button.dataset.platform;

				// If the button is clicked, open the modal
				singleDownloadModal.classList.add('show');

				// Now lets add the data attributes to the form
				modalForm.dataset.connector = connector;
				modalForm.dataset.redirect = redirect;
				modalForm.dataset.postName = postName;
			});
		});

		// Watch the form
		modalForm.addEventListener('submit', (e) => {
			// Stop the submit
			e.preventDefault();

			// Grab all the dataset stuff
			const connector = modalForm.dataset.connector;
			const redirect = modalForm.dataset.redirect;
			const postName = modalForm.dataset.postName;
			const region = modalForm.dataset.region;
			const formId = modalForm.dataset.formId;
			const portalId = modalForm.dataset.portalId;

			submitHubspotForm(modalForm, connector, redirect, postName, region, formId, portalId);
		});


		// Watch the close button
		const closeBtn = singleDownloadModal.querySelector('.st-modal-close');

		// If there is a close button, then we want to watch it
		if (closeBtn) {
			closeBtn.addEventListener('click', (e) => {
				// Stop the default action
				e.preventDefault();

				// Hide the form
				singleDownloadModal.classList.remove('show');
			});
		}
	}



	/**
	 * Download form
	 */
	if (downloadForm && downloadFormWrapper) {
		// Lets watch the submit
		downloadForm.addEventListener('submit', (e) => {
			// Stop the submit
			e.preventDefault();

			// Grab all the dataset stuff
			const connector = downloadForm.dataset.connector;
			const redirect = downloadForm.dataset.redirect;
			const postName = downloadForm.dataset.postName;
			const region = downloadForm.dataset.region;
			const formId = downloadForm.dataset.formId;
			const portalId = downloadForm.dataset.portalId;

			submitHubspotForm(downloadForm, connector, redirect, postName, region, formId, portalId);
		});


		// Lets also watch the close button
		const closeBtn = downloadFormWrapper.querySelector('.download-form-close');

		// If there is a close button, then we want to watch it
		if (closeBtn) {
			closeBtn.addEventListener('click', (e) => {
				// Stop the default action
				e.preventDefault();

				// Hide the form
				downloadFormWrapper.classList.add('hidden');
			});
		}
	}

	/**
	 * Main page
	 */
	if (simpleTemplateGeneralCategory) {
		// Grab all the galleries
		const galleries = document.querySelectorAll('.simple-templates-general-gallery');

		// If there are galleries, then we want to initialize masonry for each
		if (galleries) {
			galleries.forEach((gallery) => {
				new Masonry( gallery, {
					// options...
					itemSelector: '.simple-templates-archive-card',
					gutter: '.gutter-sizer',
				});
			});
		}

		// Now lets grab the categories we have
		const categories = document.querySelectorAll('.st-main-archive-cat');

		// Grab all the data-ids
		const categoryIds = [];

		// Loop through and grab the ids
		categories.forEach((category) => {
			categoryIds.push(category.dataset.catId);
		});

		// Now lets keep the last category
		const lastCategory = categories[categories.length - 1];

		// Now lets wait until it is in view
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Lets now add the remaining categories\
					// Build the form data
					const formData = new FormData();

					// Append the action
					formData.append('action', 'coefficient_simple_templates_main_archive_get_remaining');

					// Append the category ids
					formData.append('category_ids', categoryIds.join(','));

					// Now we fetch
					fetch('/wp-admin/admin-ajax.php', {
						method: 'POST',
						body: formData,
					})
					.then((response) => {
						return response.text();
					})
					.then((data) => {
						console.log('GRABBED');
						// Lets stop observing
						observer.unobserve(lastCategory);

						// Now lets add the response to the main archive
						simpleTemplateGeneralCategory.innerHTML += data;

						// Now lets initialize masonry for the new cards
						const newGalleries = document.querySelectorAll('.st-main-archive-cat-api .simple-templates-general-gallery');

						// Create a new masonry for each
						newGalleries.forEach((gallery) => {
							new Masonry( gallery, {
								// options...
								itemSelector: '.simple-templates-archive-card',
								gutter: '.gutter-sizer',
							});
						});

					})
					.catch((error) => {
						console.log(error);
					});
				}
			});
		});

		// Now lets observe the last category
		observer.observe(lastCategory);
	}


	/**
	 * More button for taxonomy and single pages
	 */
	if (simpleTemplatesMoreBtn) {
		// Grab the icon
		const icon = simpleTemplatesMoreBtn.querySelector('.fa-solid');

		simpleTemplatesMoreBtn.addEventListener('click', (e) => {
			// Stop default action
			e.preventDefault();

			// Log in the console
			console.log('Getting another 12 posts');

			// Lets quickly change the arrow icon to a loading spinner
			icon.classList.remove('!hidden');

			// Grab the data attributes
			const type = simpleTemplatesMoreBtn.dataset.type;
			let excludedPosts = simpleTemplatesMoreBtn.dataset.excludedPosts;

			// Lets exclude any current posts and any posts that have already been grabbed
			const posts = document.querySelectorAll('.simple-templates-archive-card');

			// Make excluded posts an array
			excludedPosts = excludedPosts.split(',');

			// Now lets loop through and add them to the excluded posts
			posts.forEach((post) => {
				// Grab the post id
				const postId = post.dataset.postId;

				// Lets make sure that postId is not equal to 'variation'
				if (postId === 'variation') {
					return;
				}

				// If the post id is not in the excluded posts, then we want to add it
				if (!excludedPosts.includes(postId)) {
					excludedPosts.push(postId);
				}
			});

			// Now lets join the excluded posts
			excludedPosts = excludedPosts.join(',');

			// Now lets update the excluded posts data attribute
			simpleTemplatesMoreBtn.dataset.excludedPosts = excludedPosts;

			// Also grab the stage
			const stage = getStage(posts);

			// Lets build our form data for the post fetch
			const formData = new FormData();

			// Depending on the type this will change
			if (type === 'taxonomy') {
				// Grab the current taxonomy from the data attribute
				const taxonomy = simpleTemplatesMoreBtn.dataset.taxonomy;

				// Apend the form data
				formData.append('action', 'coefficient_simple_templates_taxonomy_get_more');
				formData.append('taxonomy', taxonomy);
			}
			else if (type === 'single') {
				// Grab the secondary categories
				const secondaryCats = simpleTemplatesMoreBtn.dataset.secondaryCats;

				// Apend the form data
				formData.append('action', 'coefficient_simple_templates_single_get_more');
				formData.append('secondary_cats', secondaryCats);
				formData.append('stage', stage);

				console.log(stage);
			}
			else {
				return;
			}

			// Add the general attributes
			formData.append('excluded_posts', excludedPosts);

			// Now we fetch
			fetch('/wp-admin/admin-ajax.php', {
				method: 'POST',
				body: formData,
			})
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				// Save if these are variations
				let isVariationSet = false;

				// If the response is simply 'delete' then there are either no posts or no more posts
				if (data === 'delete') {
					console.log('No more posts to grab');
					// Remove the button container
					simpleTemplatesMoreBtn.parentNode.remove();
				} else {
					// Convert the data to html
					const html = new DOMParser().parseFromString(data, 'text/html');

					// Grab all the cards
					const cards = html.querySelectorAll('.simple-templates-archive-card');

					// For each card, we want to append it to the archive
					cards.forEach((card) => {
						// If any of the cards are variations, then we want to set the isVariationSet to true
						if (card.dataset.postId === 'variation' && !isVariationSet) {
							isVariationSet = true;
						}

						// Now lets append it to the archive
						mainArchiveGallery.appendChild(card);
						msnry.appended(card);
					});

					msnry.layout();

					// Lets also be sure to set the has grabbed attribute
					simpleTemplatesMoreBtn.dataset.hasGrabbed = 'true';

					// If there were variations, then we want to hide the button
					if (type !== 'single' && isVariationSet) {
						simpleTemplatesMoreBtn.parentNode.remove();
					}
					else if (type === 'single' && stage === 'secondary-categories') {
						simpleTemplatesMoreBtn.parentNode.remove();
					}
					else {
						console.log('Button is still visible');
					}
				}

				// Lets hide the loading spinner
				icon.classList.add('!hidden');
			})
			.catch((error) => {
				console.log(error);
				alert( 'There was an error loading items. Please contact support@coefficient.io if this issue persists' );
			});
		});
	}
}());


/**
 * Handle the see more button
 * @param {*} button The button that was clicked
 */
const coeffTemplateSeeMore = (button) => {
	// Grab the data-target
	const target = button.dataset.target;

	// Select the target
	const targetEl = document.getElementById(target);

	// If the classlist contains hidden, then remove it and change the button text
	if (targetEl.classList.contains('template-see-more-hidden')) {
		targetEl.classList.remove('template-see-more-hidden');
		button.innerHTML = 'See Less';
	} else {
		targetEl.classList.add('template-see-more-hidden');
		button.innerHTML = 'See More';

		// If there is a see more toc, then lets hide it
		if (seeMoreToc) {
			seeMoreToc.classList.add('hidden');
		}
	}
}


const coeffStFireForm = (btn, connector, containerId, redirect, postName) => {
	// If any of these are missing
	if (!btn || !connector || !containerId || !redirect || !postName) {
		return;
	}

	// Lets grab the only form on the page
	const formCard = document.getElementById('st-form-card');

	// If there is no form card, then we dump
	if (!formCard) {
		return;
	}

	// If there is a form card, lets move it to our container
	const container = document.getElementById(containerId);

	// If there is no container, then we dump
	if (!container) {
		return;
	}

	// Now lets move the form card to the container
	container.appendChild(formCard);

	// Show the form card
	formCard.classList.remove('hidden');

	// Now lets grab the form
	const form = formCard.querySelector('form');

	// If there is no form, then we dump
	if (!form) {
		return;
	}

	// Now lets update the data attributes
	form.dataset.connector = connector;
	form.dataset.redirect = redirect;
	form.dataset.postName = postName;
}